import { FILTER_TYPES, PAGE_SIZE_FILTER } from 'constants/filterType';
import { STOCKTAKING_STATUS_OPTIONS } from 'constants/stocktaking/status';

export const STOCKTAKING_FILTER_OPTIONS = [
  {
    field: 'status',
    label: 'Status',
    type: FILTER_TYPES.MULTI_SELECT,
    options: STOCKTAKING_STATUS_OPTIONS,
  },
  { ...PAGE_SIZE_FILTER },
];
